export default "__VITE_PUBLIC_ASSET__a8eb7e70__"